"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_query_1 = require("@tanstack/react-query");
const bookingSlice_1 = require("../../../store/slices/bookingSlice");
const LoadingButton_1 = __importDefault(require("../../../components/LoadingButton"));
const store_1 = require("../../../store/store");
const axios_1 = __importDefault(require("axios"));
const dayjs_1 = __importDefault(require("dayjs"));
const Button_1 = require("../../../components/Button");
const Confirm = ({ appointment, bookingFlowType, }) => {
    const { slotId, donationType, calendarId, date, appointmentId, slotFromDate, slotToDate } = (0, store_1.useAppSelector)((state) => state.booking.currentBooking);
    const isRebooking = bookingFlowType === 'rebook';
    const appSettings = (0, store_1.useAppSelector)((state) => state.app.appSettings);
    const [done, setDone] = (0, react_1.useState)(false);
    const [success, setSuccess] = (0, react_1.useState)(false);
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const dispatch = (0, store_1.useAppDispatch)();
    const queryClient = (0, react_query_1.useQueryClient)();
    const confirmBooking = () => {
        setIsLoading(true);
        const payload = isRebooking
            ? {
                calendarId,
                fromDate: slotFromDate,
                toDate: slotToDate,
                existingAppointmentId: (appointment === null || appointment === void 0 ? void 0 : appointment.appointmentId) || appointmentId,
                donationType,
            }
            : {
                slotId,
                donationType,
            };
        const endpoint = isRebooking
            ? '/api/booking/rebook-appointment'
            : '/api/booking/create-appointment';
        axios_1.default
            .post(endpoint, payload)
            .then((res) => {
            var _a, _b;
            const newAppointmentId = (_b = (_a = res.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.appointmentId;
            if (newAppointmentId || res.status === 200) {
                dispatch((0, bookingSlice_1.updateCurrentBooking)({
                    prop: 'appointmentId',
                    value: newAppointmentId || (appointment === null || appointment === void 0 ? void 0 : appointment.appointmentId),
                }));
                setSuccess(true);
            }
            else {
                setSuccess(false);
            }
        })
            .catch((err) => {
            console.error('Error:', err);
            console.error('Error Details:', err.response ? err.response.data : 'No response data');
            setSuccess(false);
        })
            .finally(() => {
            setDone(true);
            setIsLoading(false);
            queryClient.invalidateQueries({ queryKey: ['get-coming-appointments'] });
            queryClient.invalidateQueries({ queryKey: ['bookable-dates'] });
        });
    };
    const bookingDone = () => {
        setSuccess(false);
        setDone(false);
        dispatch((0, bookingSlice_1.clearCurrentBooking)());
        dispatch((0, bookingSlice_1.closeModal)());
    };
    const renderConfirmDialog = () => {
        const heading = isRebooking ? `booking.rebooking-confirm-heading` : `booking.confirm-heading`;
        return ((0, jsx_runtime_1.jsxs)("div", { className: "text-start", children: [(0, jsx_runtime_1.jsx)("h4", { children: __.trans(heading) }), (0, jsx_runtime_1.jsx)("hr", { className: "text-muted" }), (0, jsx_runtime_1.jsx)("h3", { children: (0, jsx_runtime_1.jsxs)("strong", { children: [(0, dayjs_1.default)(date.selectedDate).format(appSettings === null || appSettings === void 0 ? void 0 : appSettings.dateFormat), ", ", date.selectedTime] }) }), (0, jsx_runtime_1.jsx)("hr", { className: "text-muted" }), (0, jsx_runtime_1.jsx)("p", { dangerouslySetInnerHTML: { __html: __.trans('booking.confirmation-text') } }), (0, jsx_runtime_1.jsx)(LoadingButton_1.default, { isLoading: isLoading, children: (0, jsx_runtime_1.jsx)(Button_1.Button, { className: "btn btn-lg theme-button-primary mt-5", onClick: confirmBooking, children: __.trans('booking.confirm-button') }) })] }));
    };
    const renderDone = () => {
        const status = success ? 'successful' : 'unsuccessful';
        const message = isRebooking
            ? `booking.rebooking-confirmation-${status}`
            : `booking.confirmation-text-${status}`;
        return ((0, jsx_runtime_1.jsxs)("div", { className: "text-start", children: [(0, jsx_runtime_1.jsx)("h4", { children: __.trans(`booking.done-heading-${status}`) }), (0, jsx_runtime_1.jsx)("p", { dangerouslySetInnerHTML: { __html: __.trans(message) } }), success && (0, jsx_runtime_1.jsx)("p", { children: `${__.trans('booking.confirmation-appointment-id')} ${appointmentId}` }), (0, jsx_runtime_1.jsx)(Button_1.Button, { className: "btn btn-lg theme-button-primary mt-5", onClick: bookingDone, children: __.trans(`booking.confirmation-done-button-${status}`) })] }));
    };
    const renderContent = () => {
        if (!done)
            return renderConfirmDialog();
        return renderDone();
    };
    return (0, jsx_runtime_1.jsx)("div", { className: "p-4", children: renderContent() });
};
exports.default = Confirm;
